import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import {
  AggregatedForecastItem,
  ForecastFilter,
  PaginatedForecastResult
} from '../types';
import { PensionScheme } from '../../pensionScheme/types';
import { IForecastState } from './state';
/**
 * --------------------------------------------------
 *	Forecast Getters
 * --------------------------------------------------
 **/
export const ForecastGetters: IForecastGetters = {
  forecast: (state: IForecastState): PaginatedForecastResult | null =>
    state.forecast,
  forecastFilters: (state: IForecastState): ForecastFilter =>
    state.forecastFilters,
  orgClients: (state: IForecastState): PensionScheme[] =>
    state.organizationClients,
  aggregatedForecastDetails: (
    state: IForecastState
  ): AggregatedForecastItem[] => state.aggregatedForecastDetails
};

/**
 * --------------------------------------------------
 *	Forecast Getters Interface
 * --------------------------------------------------
 **/
export interface IForecastGetters
  extends GetterTree<IForecastState, IRootState> {
  forecast(state: IForecastState): PaginatedForecastResult | null;
  forecastFilters(state: IForecastState): ForecastFilter;
  orgClients(state: IForecastState): PensionScheme[];
  aggregatedForecastDetails(state: IForecastState): AggregatedForecastItem[];
}
